(function () {
  'use strict';
  if (window.WearHubPaymentCart) return;
  var DOLLAR = 67469758431522;
  var CENT = 67553689141538;
  var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pending = false;
  var verifiedForm = null;

  function isPayment(item) {
    return /^WH-PAY-/i.test(String(item.sku || '')) || Number(item.variant_id) === DOLLAR || Number(item.variant_id) === CENT;
  }
  function amountCents(raw) {
    var text = String(raw == null ? '' : raw).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
    var parts = text.split('.');
    var value = Number(parts[0]) * 100 + Number(((parts[1] || '') + '00').slice(0, 2));
    return Number.isSafeInteger(value) ? value : null;
  }
  function groupId(item) {
    return String((item.properties || {})['_Order Session'] || 'legacy:' + item.key);
  }
  function validate(cart) {
    var payments = (cart.items || []).filter(isPayment);
    if (!payments.length) return '';
    if (String(cart.currency || 'USD') !== 'USD') return 'Please switch to USD and reopen the approved payment page before checking out.';
    var groups = Object.create(null);
    payments.forEach(function (item) {
      var key = groupId(item);
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    var problem = '';
    Object.keys(groups).some(function (key) {
      var lines = groups[key];
      var expected = null;
      var dollars = 0;
      var cents = 0;
      var actual = 0;
      var modern = false;
      var bad = false;
      lines.forEach(function (item) {
        var properties = item.properties || {};
        var stated = properties['_Approved Amount Cents'];
        var approved;
        if (stated != null && String(stated) !== '') {
          modern = true;
          approved = /^\d+$/.test(String(stated)) ? Number(stated) : NaN;
          if (!properties['_Order Session']) bad = true;
        } else {
          approved = amountCents(properties['Approved Order Amount (USD)']);
        }
        // Older whole-dollar payments may predate the approval properties.
        if (approved == null && lines.length === 1 && Number(item.variant_id) === DOLLAR) approved = Number(item.quantity) * 100;
        if (!Number.isSafeInteger(approved) || approved < 5000 || approved > 5000000) bad = true;
        if (expected !== null && approved !== expected) bad = true;
        expected = approved;
        var quantity = Number(item.quantity);
        if (!Number.isSafeInteger(quantity) || quantity < 1) bad = true;
        if (Number(item.variant_id) === DOLLAR) {
          dollars += quantity;
          if (modern && properties['_Payment Component'] !== 'dollars') bad = true;
        } else if (Number(item.variant_id) === CENT) {
          cents += quantity;
          if (!properties['_Order Session'] || properties['_Payment Component'] !== 'cents') bad = true;
        } else {
          bad = true;
        }
        var lineTotal = Number(item.final_line_price);
        if (!Number.isSafeInteger(lineTotal)) bad = true;
        actual += lineTotal;
      });
      if (bad || dollars !== Math.floor(expected / 100) || cents !== expected % 100 || actual !== expected) {
        problem = 'Your custom payment is incomplete or its total no longer matches the approved amount. Remove this payment and enter the approved amount again.';
        return true;
      }
      return false;
    });
    if (problem) return problem;
    // An order-wide goods discount can reduce a quote even when its payment lines have no line discount.
    var orderDiscount = (cart.cart_level_discount_applications || []).some(function (discount) {
      return discount.target_type !== 'shipping_line' && Number(discount.total_allocated_amount || 0) > 0;
    });
    if (orderDiscount) return 'Approved custom payments cannot use order discounts. Remove the discount code before continuing.';
    return '';
  }
  async function getCart() {
    var response = await fetch(rootPath + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('We could not verify your payment amount. Please try again before checking out.');
    return response.json();
  }
  function showError(message, anchor) {
    var scope = (anchor && anchor.closest && anchor.closest('hdt-cart-drawer,hdt-main-cart,#CartDrawer')) || document.getElementById('hdt-page-cart') || document.body;
    var box = scope.querySelector('[data-wh-payment-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-wh-payment-cart-error', '');
      box.className = 'wh-payment-cart-error';
      box.setAttribute('role', 'alert');
      box.setAttribute('tabindex', '-1');
      var form = anchor && (anchor.form || (anchor.tagName === 'FORM' ? anchor : null));
      var target = form || scope.querySelector('form[action*="/cart"]');
      if (target) target.insertAdjacentElement('afterend', box); else scope.prepend(box);
    }
    box.textContent = message;
    var link = document.createElement('a');
    link.href = rootPath + 'products/custom-order-payment-approved-quote-only?payment_version=20261020';
    link.textContent = 'Return to the approved payment page';
    box.appendChild(link);
    box.hidden = false;
    box.focus();
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function clearErrors() {
    document.querySelectorAll('[data-wh-payment-cart-error]').forEach(function (box) { box.hidden = true; });
  }
  async function removePayment(button) {
    if (pending) return;
    pending = true;
    button.disabled = true;
    clearErrors();
    try {
      var cart = await getCart();
      var session = button.getAttribute('data-wh-payment-session');
      var key = button.getAttribute('data-wh-line-key');
      var selected = (cart.items || []).filter(function (item) {
        return isPayment(item) && (session ? String((item.properties || {})['_Order Session'] || '') === session : item.key === key);
      });
      if (!selected.length) { window.location.assign(rootPath + 'cart'); return; }
      var updates = {};
      selected.forEach(function (item) { updates[item.key] = 0; });
      var response = await fetch(rootPath + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) throw new Error('The payment could not be removed. Please try again.');
      var checked = await getCart();
      var remains = (checked.items || []).some(function (item) {
        return isPayment(item) && (session ? String((item.properties || {})['_Order Session'] || '') === session : item.key === key);
      });
      if (remains) throw new Error('The payment was not fully removed. Please try again before checking out.');
      window.location.assign(rootPath + 'cart');
    } catch (error) {
      showError(error.message || 'Unable to remove this payment. Please try again.', button);
      pending = false;
      button.disabled = false;
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-wh-remove-payment]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removePayment(button);
  }, true);
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (form.id !== 'CartPage-Form' && form.id !== 'CartDrawer-Form') return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (verifiedForm === form) { verifiedForm = null; return; }
    if (!form.querySelector('[data-wh-payment-line]') && !form.querySelector('[data-wh-remove-payment]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    submitter.setAttribute('aria-busy', 'true');
    clearErrors();
    try {
      var cart = await getCart();
      var problem = validate(cart);
      if (problem) throw new Error(problem);
      // Re-enter the original form path so the existing required Terms checkbox is still enforced.
      if (!form.reportValidity()) return;
      verifiedForm = form;
      form.requestSubmit(submitter);
    } catch (error) {
      showError(error.message || 'Unable to verify the approved payment. Please try again.', form);
    } finally {
      pending = false;
      submitter.removeAttribute('aria-busy');
      verifiedForm = null;
    }
  }, true);
  window.WearHubPaymentCart = { isPayment: isPayment, validate: validate };
})();
